import { type Allergen } from '@sg/graphql-schema';
import { type AllergenTypes } from '@sg/shared-fe-features-menu';

/**
 * Converts the dietary preferences object to a list of selected allergens.
 */
export function getDietaryPreferencesList(dietaryPreferences: AllergenTypes): Allergen[] {
  const preferencesKeys = Object.keys(dietaryPreferences) as Allergen[];

  return preferencesKeys.filter((allergen) => Boolean(dietaryPreferences[allergen]));
}
